import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../services/WiMuleSQL";

const fetchMachineIDTranslator = async (url) => {
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "text/plain",
    },
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  return response.json();
};

export const useGetMachineIdTranslator = ({ machine }) => {
  // Construct the URL here
  const url = machine
    ? `${WiMuleSQL}/api/MachineFaults/GetMachineIDTranslatorList?bwosId=${encodeURIComponent(
        machine
      )}`
    : `${WiMuleSQL}/api/MachineFaults/GetMachineIDTranslatorList`;

  console.log("URL", url);

  return useQuery({
    queryKey: ["machineIDTranslator", url],
    queryFn: () => {
      console.log("Executing fetch with URL:", url);
      return fetchMachineIDTranslator(url);
    },
    staleTime: 4 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    onError: (error) => {
      console.error("Failed to fetch machine ID translator:", error.message);
    },
  });
};
